import React, {useEffect, useState} from 'react';
import {saveCurrentTheme} from "../../store/reducers/preferences";
import {useDispatch} from "react-redux";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import {styled} from "@mui/styles";
import Switch from "@mui/material/Switch";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({theme}) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: theme.palette.secondary.main,
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#33cf4d",
            border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));

const useStyle = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
    },
    spaceBetween: {
        margin: "0px 5px",
    },
    notSelected: {
        color: "grey"
    }
}));

const SwitchThemeButton = ({disableSave = false}) => {
    const dispatch = useDispatch();
    const classes = useStyle();

    const currentTheme = window._getTheme();

    const [darkMode, setDarkMode] = useState(currentTheme === "dark");

    useEffect(() => {
        const isDarkMode = currentTheme === 'dark';

        setDarkMode(isDarkMode);
    }, [currentTheme])

    const switchTheme = () => {
        setDarkMode(prev => !prev);
        window._switchTheme();
        if (disableSave) dispatch(saveCurrentTheme(window._getTheme()));
    };

    return (
        <div className={classes.root}>
            <LightModeIcon className={clsx(darkMode && classes.notSelected)}/>
            <IOSSwitch
                className={classes.spaceBetween}
                checked={darkMode}
                onClick={switchTheme}
            />
            <DarkModeIcon className={clsx(!darkMode && classes.notSelected)}/>
        </div>
    );
};

export default SwitchThemeButton;